function ScopeComponent(Component) {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"03beeb9"}`, "");
  });
}
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-CTeSJqUJ.mjs.map
